module.exports = __webpack_public_path__ + "static/001-5ab5b2a2966102960aeeee7154b1f17b.jpg";